<form
  autocomplete="off"
  class="bn-search"
  [formGroup]="form">
  <div (click)="onInputClick()">
    <bn-web-ui-input
      borderRadius="lg"
      formControlName="searchTerm"
      size="xs"
      [itemStyle]="form.controls.searchTerm.value ? 'primary' : 'secondary'"
      [loading]="isLoading"
      [options]="{
        removePadding: true,
        leftAddons: leftInputAddons,
        rightAddons: !isLoading ? rightInputAddons : [],
      }"
      [placeholder]="placeholder"
      (clickAction)="onAddonClick($event)" />
  </div>
  @if (isOpen) {
    <ng-content />
  }
</form>
